module.exports = __webpack_public_path__ + "static/media/landing-slider-img-1-mobile.9f0c5372.jpg";